const templateUrl = require('./inactive-subscription.html');

module.exports = {
  require: require('./list/inactive-subscriptions.controller'),
  bindings: {
    subscription: '<ogFor'
  },
  templateUrl: templateUrl
};
